/**
 * Default PDF Viewer sample
 */
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import * as React from "react";
import "./pdf.component.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import { Button, Flex, Select } from "@mantine/core";
import {
  LocalizationMap,
  ScrollMode,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { scrollModePlugin } from "@react-pdf-viewer/scroll-mode";
import { useEffect } from "react";
import { repositorySign, workerUrl } from "../../_base/_const/_constVar";
import { EcmNodeContent } from "../../model/EcmNodeContent";
import { MessageResponse } from "../../model/MessageResponse";
import { getFileNames } from "../../_base/extension/Extension";
import CheckSign from "../../component/CheckSign";
function PdfOnlyViewer({
  files,
  cache,
}: {
  files: string | string[];
  cache?: boolean;
}) {

  type PageLayout = {
    transform: (pageIndex: number) => { rotate: number };
    size: ({ height, width }: { height: number; width: number }) => {
      height: number;
      width: number;
    };
    buildPageStyles: () => React.CSSProperties;
  };

  // Xử lý danh sách file
  const urlFile = Array.isArray(files) ? files : files ? files.split("||") : [];
  const [selectFile, setSelectFile] = React.useState<string>(urlFile[0] || "");
  const [cacheBustedUrl, setCacheBustedUrl] = React.useState<string>("");
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const scrollModePluginInstance = scrollModePlugin();
  const [pageTotal, setPageTotal] = React.useState<number>(1);
  const [fileNames, setFileNames] = React.useState<EcmNodeContent[]>([]);
  useEffect(() => {
    const getNameFile = async () => {
      const res = await getFileNames(urlFile);
      setFileNames(res || []);
    };
    getNameFile();
  }, []);
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  useEffect(() => {
    if (urlFile.length > 0) setSelectFile(urlFile[0]);
  }, [files]);
  useEffect(() => {
    if (!selectFile) {
      setCacheBustedUrl("");
      return;
    }
    if (cache === false) {
      setCacheBustedUrl(selectFile);
    } else {
      const separator = selectFile.includes("?") ? "&" : "?";
      setCacheBustedUrl(`${selectFile}${separator}_t=${Date.now()}`);
    }
  }, [selectFile, cache]);

  const handleDownload = async () => {
    const response = await fetch(selectFile);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download =
      fileNames.find((file) => file.fileName === selectFile.split("/").pop())
        ?.originName ??
      selectFile.split("/").pop() ??
      "file.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const horizontalLayout: PageLayout = {
    transform: (pageIndex: number) => ({ rotate: 0 }),
    size: ({ height, width }) => ({ height, width }),
    buildPageStyles: () => ({
      margin: "0 8px", // Horizontal margin
      display: "inline-block", // Display inline for horizontal stacking
    }),
  };

  return (
    <div>
      <Flex gap="xs" justify="space-between" mb={10} align="center" w={"100%"}>
        <Select
          label="Chọn tài liệu"
          placeholder="Chọn..."
          value={selectFile}
          onChange={(e) => setSelectFile(e ?? "")}
          data={urlFile.map((x) => ({
            label:
              fileNames.find((file) => file.fileName === x.split("/").pop())
                ?.originName ??
              x.split("/").pop() ??
              "Tài liệu",
            value: x,
          }))}
          w={250}
        />
        <Button onClick={handleDownload}>Tải xuống file gốc</Button>
        <CheckSign fileUrl={selectFile} />
      </Flex>
      <div className="control-section">
        {cacheBustedUrl && (
          <div
            className="rpv-core__viewer"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "70vh",
            }}
          >
            <Worker workerUrl={workerUrl}>
              <Viewer
                localization={de_DE as unknown as LocalizationMap}
                plugins={[
                  defaultLayoutPluginInstance,
                  pageNavigationPluginInstance,
                ]}
                pageLayout={horizontalLayout}
                fileUrl={cacheBustedUrl}
                onPageChange={(e) => {
                  if (pageTotal !== e.doc.numPages)
                    setPageTotal(e.doc.numPages);
                }}
                scrollMode={ScrollMode.Vertical}
                defaultScale={1}
              />
            </Worker>
          </div>
        )}
      </div>
    </div>
  );
}
export default PdfOnlyViewer;
